export const StudentSatisfactionFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 50, text: '國立臺灣科技大學校外實習問卷調查表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    { w: '100%', h: 190, not_take_space: true },
    {
      w: '100%', h: 30, padding: 10, text: '校外實習同學 您好：',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 130, padding: 30, text: '　　本問卷為本校欲瞭解同學在參與校外實習後，對於自我實務技能及就業競爭力的提升或是自我成長是否有所助益，並可提供學校規劃校外實習課程時能更加完備。\n本問卷僅進行整體分析，不涉及個別資料判別，請同學撥冗詳實填答。\n您的寶貴意見將對未來的學弟妹們，能更加順利進行校外實習。\n在此致上謝意！\n敬祝  身體健康，學業進步！',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 30, padding: 10, text: '國立臺灣科技大學 敬啟',
      border_width: 0, align: 'right', font_family: '標楷體',
    },

    {
      w: '100%', h: 30, text: '壹、參與校外實習課程期間',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '實習期間' },
    { w: '82%', h: 30, text: `${form_data.school_year} 學年度 ${form_data.semester} (期間：${date_to_str(form_data.start_time)}～${date_to_str(form_data.end_time)})` },

    { w: '18%', h: 30, text: '學號' },
    { w: '32%', h: 30, text: form_data.student_account },
    { w: '18%', h: 30, text: '姓名' },
    { w: '32%', h: 30, text: form_data.student_name },

    { w: '18%', h: 30, text: '就讀系所' },
    { w: '32%', h: 30, text: form_data.department_id },
    { w: '18%', h: 30, text: '實習機構' },
    { w: '32%', h: 30, text: form_data.internship },

    { w: '18%', h: 30, text: '實習地點' },
    { w: '82%', h: 30, text: form_data.intern_address },

    {
      w: '100%', h: 30, text: '貳、實習課程分類',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { w: '100%', h: 120, align: 'left', padding: 20, border_width: 0, all_wrap: true, texts: form_data.classified },

    {
      w: '100%', h: 30, text: '參、您參與實習課程的年級',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '100%', h: 30, align: 'left', border_width: 0, text: '(一)暑期實習', },
    { w: '100%', h: 30, align: 'left', padding: 20, border_width: 0, texts: form_data.summer_intern },

    { w: '100%', h: 30, align: 'left', border_width: 0, text: '(二)學期實習/學年實習', },
    { w: '75%', h: 50, align: 'left', padding: 20, border_width: 0, texts: form_data.school_intern },

    { w: '100%', h: 30, align: 'left', border_width: 0, text: '(三)專業成長實習', },
    {
      w: '100%', h: 30, align: 'left', padding: 20, border_width: 0,
      text: `自 ${form_data.start_class} 年級 ${form_data.start_semester} 學期～ ${form_data.end_class} 年級 ${form_data.end_semester} 學期`,
    },

    {
      w: '100%', h: 30, text: '肆、校外實習滿意度調查',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '一、行政運作' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常同意: 1, 同意: 2, 普通: 3, 不同意: 4, 非常不同意: 5 )' },
    ...check_radio_table_key_check(blueprint, form_data.check, 0, 5),

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '二、課程規劃' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常同意: 1, 同意: 2, 普通: 3, 不同意: 4, 非常不同意: 5 )' },
    ...check_radio_table_key_check(blueprint, form_data.check, 5, 3),

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '三、報酬與環境' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常同意: 1, 同意: 2, 普通: 3, 不同意: 4, 非常不同意: 5 )' },
    ...check_radio_table_key_check(blueprint, form_data.check, 8, 4),

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '四、實習輔導' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常同意: 1, 同意: 2, 普通: 3, 不同意: 4, 非常不同意: 5 )' },
    ...check_radio_table_key_check(blueprint, form_data.check, 12, 3),

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '五、校外實習成效' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常同意: 1, 同意: 2, 普通: 3, 不同意: 4, 非常不同意: 5 )' },
    ...check_radio_table_key_check(blueprint, form_data.check, 15, 14),

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '六、其他' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(有: 1, 無: 2, 不清楚: 3 )' },
    ...check_radio_table(blueprint.find(block => block.key == 'other_check').items, form_data.other_check),

    {
      w: '100%', h: 30, text: '伍、校外實習建議',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { w: '100%', h: 100, padding: 10, align: 'left', baseline: 'top', text: form_data.suggest },
    { w: '100%', h: 60, border_width: 0, font_style: 'bold', font_family: '標楷體', text: '謝謝您的填答，並預祝您學業順利。' },
  ];
}

function check_radio_table_key_check(blueprint, values, start_index, count) {
  return blueprint.find(block => block.key == 'check').items
  .filter(item => !Array.isArray(item)).slice(start_index, start_index + count)
  .map((item, index) => {
    return [
      { w: '70%', h: 30, padding: 10, align: 'left', text: item },
      { w: '30%', h: 30, padding: 10, texts: values[index + start_index] },
    ];
  }).flat();
}

function check_radio_table(items, values) {
  return items.map((item, index) => {
    return [
      { w: '70%', h: 30, padding: 10, align: 'left', text: item },
      { w: '30%', h: 30, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}